import { render, staticRenderFns } from "./IconPlugin.vue?vue&type=template&id=89e1dace"
import script from "./IconPlugin.vue?vue&type=script&lang=js"
export * from "./IconPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports